<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>客服檢視</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="container">
      <form class="row">
        <div class="col-sm-6 offset-md-6 word_center col-md-offset-4">
          <div class="col-sm-5 fontSize16 selectstyle">客服姓名:</div>
          <h4>{{ $route.params.list.name }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 selectstyle"
        >
          <div class="col-sm-5 fontSize16 selectstyle">員工聯絡電話:</div>
          <h4>{{ $route.params.list.contactPhone }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 selectstyle"
        >
          <div class="col-sm-5 fontSize16 selectstyle">
            客服中心聯絡電話＋編號:
          </div>
          <h4>{{ $route.params.list.servicePhone }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 selectstyle"
        >
          <div class="col-sm-5 fontSize16 selectstyle">Email:</div>
          <h4>{{ $route.params.list.email }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 selectstyle"
        >
          <div class="col-sm-5 fontSize16 selectstyle">登入帳號:</div>
          <h4>{{ $route.params.list.account }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 selectstyle"
        >
          <div class="col-sm-5 fontSize16 selectstyle">備註:</div>
          <h4>{{ $route.params.list.note }}</h4>
        </div>
        <div
          class="col-sm-6 offset-md-6 word_center col-md-offset-4 textmargin"
        >
          <button
            type="button"
            @click="onDeleteBtnClick"
            class="mybtnstyle btn-danger selectstyle"
            v-show="isAuthorized"
          >
            刪除人員
          </button>
          <button
            @click="onShowEditTable"
            type="button"
            class="mybtnstyle btn-dark selectstyle"
            v-show="isAuthorized"
          >
            編輯資料
          </button>
          <button
            @click="onEditPassword"
            type="button"
            class="mybtnstyle btn-warning selectstyle"
          >
            修改密碼
          </button>
        </div>
      </form>
      <div
        id="myModal"
        class="edit-payment row"
        v-show="show_edit_model"
        style="display: none"
      >
        <div class="edit-payment-content row">
          <div class="col-sm-12 col-md-12 word_center">
            <div class="col-sm-5 fontSize16 selectstyle">客服姓名:</div>
            <input
              v-model="server.name"
              type="text"
              class="inputstyle col-md-6 fontSize16"
              :placeholder="$route.params.list.name"
            />
          </div>
          <div class="col-sm-12 col-md-12 word_center selectstyle">
            <div class="col-sm-5 fontSize16 selectstyle">員工聯絡電話:</div>
            <input
              v-model="server.contact"
              type="text"
              class="inputstyle col-md-6 fontSize16"
              :placeholder="$route.params.list.contactPhone"
            />
          </div>
          <div class="col-sm-12 col-md-12 word_center selectstyle">
            <div class="col-sm-5 fontSize16 selectstyle">客服中心聯絡電話:</div>
            <input
              v-model="server.serviceContact"
              type="text"
              class="inputstyle col-md-6 fontSize16"
              :placeholder="$route.params.list.servicePhone"
            />
          </div>
          <div class="col-sm-12 col-md-12 word_center selectstyle">
            <div class="col-sm-5 fontSize16 selectstyle">Email:</div>
            <input
              v-model="server.email"
              type="text"
              class="inputstyle col-md-6 fontSize16"
              :placeholder="$route.params.list.email"
            />
          </div>
          <div class="col-sm-12 col-md-12 word_center selectstyle">
            <div class="col-sm-5 fontSize16 selectstyle">備註:</div>
            <input
              v-model="server.note"
              type="text"
              class="inputstyle col-md-6 fontSize16"
              :placeholder="$route.params.list.note"
            />
          </div>
          <div class="col-sm-12 col-md-12 btn-right">
            <button @click="onConfirmEdit" type="button" class="btn btn-dark">
              確認編輯
            </button>
            <button
              @click="onCancelEditInfoBtnClick"
              class="btn btn-danger"
              type="button"
              name="button"
            >
              返回
            </button>
          </div>
        </div>
      </div>
      <div
        id="myModal"
        class="edit-payment row"
        v-show="show_password_edit"
        style="display: none"
      >
        <div class="edit-payment-content row">
          <div class="col-sm-12 col-md-12 word_center" v-show="!isAuthorized">
            <div class="col-sm-6 fontSize16 col-md-6 selectstyle">舊密碼:</div>
            <input
              v-model="serverPassword.oldPassword"
              type="text"
              class="inputstyle col-md-6 col-sm-6 fontSize16"
            />
          </div>
          <div class="col-sm-12 col-md-12 word_center selectstyle">
            <div class="col-sm-6 col-md-6 fontSize16 selectstyle">新密碼:</div>
            <input
              v-model="serverPassword.newPassword"
              type="text"
              class="inputstyle col-md-6 col-sm-6 fontSize16"
            />
          </div>
          <div class="col-sm-12 col-md-12 btn-right">
            <button @click="onPasswordEdit" type="button" class="btn btn-dark">
              確認編輯
            </button>
            <button
              @click="onCancelEditPasswordBtnClick"
              class="btn btn-danger"
              type="button"
              name="button"
            >
              返回
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import Manager from '../../assets/js/libs/Manager'
let manager = new Manager()

export default {
  name: 'ManagerDetail',
  props: ['list'],
  data() {
    return {
      show_edit_model: false,
      show_password_edit: false,
      manager: {
        name: '',
        position: '',
        phone: '',
        company: '',
        email: '',
        permission: null,
        account: '',
        password: '',
        old_password: '',
        note: '',
      },
      server: {
        name: null,
        contact: null,
        serviceContact: null,
        email: null,
        note: null,
      },
      serverPassword: {
        oldPassword: null,
        newPassword: null,
      },
      permission: cookies.get('GladPermission'),
    }
  },
  methods: {
    onConfirmEdit() {
      if (confirm('確認送出？')) {
        let serverEdited = {}
        // console.log(this.server.name)
        if (this.server.name !== null) {
          serverEdited.name = this.server.name
        } else if (this.server.contact !== null) {
          serverEdited.contact = this.server.contact
        } else if (this.server.serviceContact !== null) {
          serverEdited.serviceContact = this.server.serviceContact
        } else if (this.server.email !== null) {
          serverEdited.email = this.server.email
        } else if (this.server.note !== null) {
          serverEdited.note = this.server.note
        }
        API.put(
          `service/?account=${this.$route.params.list.account}`,
          serverEdited,
        ).then((data) => {
          if (data.result === '更新客服資料成功') {
            this.onCancelEditInfoBtnClick()
            this.$router.replace('/main/managerList')
          }
        })
      }
    },
    onPasswordEdit() {
      if (confirm('確認送出？')) {
        API.put(
          `service/password/?account=${this.$route.params.list.account}`,
          this.editPassword(),
        ).then((data) => {
          // console.log(data)
          if (data.result === '修改密碼成功') {
            this.$router.replace('/main/managerList')
          } else {
            alert('修改失敗,有可能是密碼錯誤')
          }
        })
      }
    },
    editPassword() {
      let editPassword = {}
      if (this.permission === '0') {
        editPassword = {
          newPassword: this.serverPassword.newPassword,
        }
        return editPassword
      } else {
        editPassword = {
          oldPassword: this.serverPassword.oldPassword,
          newPassword: this.serverPassword.newPassword,
        }
        return editPassword
      }
    },
    onCancelEditPasswordBtnClick() {
      this.show_password_edit = !this.show_password_edit
      this.onClearPasswordForm
    },
    onCancelEditInfoBtnClick() {
      this.show_edit_model = !this.show_edit_model
      this.onClearForm()
    },
    onShowEditTable() {
      this.show_edit_model = !this.show_edit_model
    },
    onDeleteBtnClick() {
      if (confirm('確認送出？')) {
        API.delete(
          `service/?customerServiceAccount=${this.$route.params.list.account}`,
        )
          .then((data) => {
            if (data.err === '權限不足') {
              alert('權限問題')
            }
            if (data.result === '封存客服資料成功') {
              alert('封存客服資料成功')
              this.$router.replace('/main/managerList')
            }
          })
          .catch((err) => {
            alert(err)
          })
      }
    },
    onEditPassword() {
      this.show_password_edit = !this.show_password_edit
    },
    setServeInfo() {
      this.server.name = $route.params.list.name
      this.server.contact = $route.params.list.servicePhone
      this.server.serviceContact = $route.params.list.contactPhone
      this.server.email = $route.params.list.email
      this.server.note = $route.params.list.note
    },
    onClearForm() {
      this.server.name = null
      this.server.contact = null
      this.server.serviceContact = null
      this.server.email = null
      this.server.note = null
    },
    onClearPasswordForm() {
      this.serverPassword.oldPassword = null
      this.serverPassword.newPassword = null
    },
  },
  computed: {
    //只有最高管理者可以做操作
    isAuthorized: function () {
      if (this.permission === '0') {
        return true
      } else {
        return false
      }
    },
    // editPassword: function(){

    // }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-right {
  text-align: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/ServerDetail.vue